/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Day_Rest_DetailInputs */

const en_us2_today_day_rest_detail = /** @type {(inputs: Today_Day_Rest_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recovery is part of training too`)
};

const pt_br2_today_day_rest_detail = /** @type {(inputs: Today_Day_Rest_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperar também faz parte do treino`)
};

const es_419_today_day_rest_detail = /** @type {(inputs: Today_Day_Rest_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperarse también es parte del entrenamiento`)
};

const pt_pt2_today_day_rest_detail = /** @type {(inputs: Today_Day_Rest_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperar também faz parte do treino`)
};

const fr_fr2_today_day_rest_detail = /** @type {(inputs: Today_Day_Rest_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupérer fait aussi partie de l'entraînement`)
};

const de_de2_today_day_rest_detail = /** @type {(inputs: Today_Day_Rest_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erholung gehört auch zum Training`)
};

const it_it2_today_day_rest_detail = /** @type {(inputs: Today_Day_Rest_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anche il recupero fa parte dell'allenamento`)
};

/**
* | output |
* | --- |
* | "Recovery is part of training too" |
*
* @param {Today_Day_Rest_DetailInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_day_rest_detail = /** @type {((inputs?: Today_Day_Rest_DetailInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Day_Rest_DetailInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_day_rest_detail(inputs)
	if (locale === "es-419") return es_419_today_day_rest_detail(inputs)
	if (locale === "pt-PT") return pt_pt2_today_day_rest_detail(inputs)
	if (locale === "fr-FR") return fr_fr2_today_day_rest_detail(inputs)
	if (locale === "de-DE") return de_de2_today_day_rest_detail(inputs)
	if (locale === "it-IT") return it_it2_today_day_rest_detail(inputs)
	return en_us2_today_day_rest_detail(inputs)
});
export { today_day_rest_detail as "today.day_rest_detail" }